'use strict';

var GridSavePostDepartureButtonDirective = function GridSavePostDepartureButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-save-post-departure-button.html'),
    controller: 'GridSavePostDepartureButtonController',
    link: function link($scope, $element) {
      $scope.$on('keyboard:save', function (ev) {
        if (isDisplayed()) {
          $scope.savePostDepartureChanges();
        }
        ev.preventDefault();
        return false;
      });
      function isDisplayed() {
        return $element.css('display') !== 'none' && $element.css('visibility') !== 'hidden';
      }
    }
  };
};
GridSavePostDepartureButtonDirective.$inject = [];
module.exports = GridSavePostDepartureButtonDirective;